import React from 'react';
import { ModeContext } from '@/contexts/ModeContext';
import { logError } from '@utils/usefulFuncs';
import styled from 'styled-components';
import { Modal } from '@ui';
import { Body5, Container } from '@ui';
import { Separator } from '@ui';
import { Header } from './components/Header';
import { ModeSelectBar } from './components/ModeSelectBar';
import { DOCUMENT_SELECTION_MODES } from './modes';
import { UploadedDocumentsSelection } from './modes/MyUploadsDocumentSelection';
import { CompanyDocumentSelection } from './modes/CompanyDocumentSelection';

const ModeContentWrapper = styled.div``;

const modalProps = {
  maximizeWidth: true,
  forceHeight: true,
};

export const DocumentSelectionModal = ({ headingText, headerAction = null, onDismiss }) => {
  const { defaultActiveDocumentSelectionMode, documentSelectionModes = [] } = React.useContext(ModeContext);
  const [docSelectMode, setDocSelectMode] = React.useState(
    defaultActiveDocumentSelectionMode || documentSelectionModes[0]
  );

  if (documentSelectionModes.length === 0) {
    logError('documentSelectionModes is not set');
    return null;
  }

  const onModeChange = (mode) => setDocSelectMode(mode);

  const renderActiveModeContent = (mode) => {
    switch (mode) {
      case DOCUMENT_SELECTION_MODES.myUploads:
        return <UploadedDocumentsSelection />;
      case DOCUMENT_SELECTION_MODES.company:
        return <CompanyDocumentSelection />;
      default:
        return <Body5>No content available for this mode</Body5>;
    }
  };

  return (
    <Modal onDismiss={onDismiss} modalProps={modalProps}>
      <Header text={headingText} onDismiss={onDismiss} />
      {headerAction}
      <Container top={28}>
        <ModeSelectBar activeMode={docSelectMode} modes={documentSelectionModes} onModeChange={onModeChange} />
      </Container>
      <Container top={24} bottom={16}>
        <Separator />
      </Container>
      <ModeContentWrapper>{renderActiveModeContent(docSelectMode)}</ModeContentWrapper>
    </Modal>
  );
};

// OLD MODE CONTENT
/*
      <Container top={0}>
        {docSelectMode === DOC_SELECT_MODES.website && (
          <WebsiteUploadsDocumentSelection
            selectedDocs={selectedDocs}
            onSelect={handleAddDocument}
            onRemoveSelect={handleRemoveDocument}
          />
        )}
        {docSelectMode === DOC_SELECT_MODES.allCompany && (
          <AllCompanyDocumentSelection
            preSelectedCompanies={preSelectedCompanies}
            selectedDocs={selectedDocs}
            onSelect={handleAddDocument}
            onRemoveSelect={handleRemoveDocument}
          />
        )}
        {docSelectMode === DOC_SELECT_MODES.docName && (
          <DocumentSearchSelection
            selectedDocs={selectedDocs}
            onSelect={handleAddDocument}
            onRemoveSelect={handleRemoveDocument}
          />
        )}
        {docSelectMode === DOC_SELECT_MODES.news && (
          <NewsDocumentSelection
            selectedDocs={selectedDocs}
            onSelect={handleAddDocument}
            onRemoveSelect={handleRemoveDocument}
          />
        )}
        {docSelectMode === DOC_SELECT_MODES.fedDoc && (
          <FedDocumentSelection
            onSelect={handleAddDocument}
            onRemoveSelect={handleRemoveDocument}
            selectedDocs={selectedDocs}
          />
        )}

        {docSelectMode === DOC_SELECT_MODES.speaker && (
          <SpeakerDocumentSelection
            onSelect={handleAddDocument}
            onRemoveSelect={handleRemoveDocument}
            selectedDocs={selectedDocs}
          />
        )}
        {docSelectMode === DOC_SELECT_MODES.docType && (
          <Container top={36}>
            <PresetDocumentSelection
              docMode={docMode}
              presetParams={docTypePresetParams}
              handleAddDocument={handleAddDocument}
              handleRemoveDocument={handleRemoveDocument}
              selectedDocs={selectedDocs}
              onDismiss={onDismiss}
            />
          </Container>
        )}
        {docSelectMode === DOC_SELECT_MODES.ppm && (
          <Container top={36}>
            <PresetDocumentSelection
              docMode={docMode}
              presetParams={{ docMode: 'ppm' }}
              handleAddDocument={handleAddDocument}
              handleRemoveDocument={handleRemoveDocument}
              selectedDocs={selectedDocs}
              onDismiss={onDismiss}
            />
          </Container>
        )}
        {docSelectMode === DOC_SELECT_MODES.credit && (
          <Container top={36}>
            <PresetDocumentSelection
              docMode={docMode}
              presetParams={{ docMode: 'credit' }}
              handleAddDocument={handleAddDocument}
              handleRemoveDocument={handleRemoveDocument}
              selectedDocs={selectedDocs}
              onDismiss={onDismiss}
            />
          </Container>
        )}
        {docSelectMode === DOC_SELECT_MODES.sector && (
          <Container top={24}>
            <SectorDocumentSelection handleAddDocuments={handleAddDocument} onDismiss={onDismiss} />
          </Container>
        )}
        {docSelectMode === DOC_SELECT_MODES.companyTag && (
          <CompanyTagDocumentSelectionWrapper>
            <CompanyTagDocumentSelection
              selectedDocs={selectedDocs}
              onSelect={handleAddDocument}
              onRemoveSelect={handleRemoveDocument}
            />
          </CompanyTagDocumentSelectionWrapper>
        )}
        {docSelectMode === DOC_SELECT_MODES.client && (
          <Container top={36}>
            <PresetDocumentSelection
              docSelectMode={docSelectMode}
              presetParams={docTypePresetParams}
              handleAddDocument={handleAddDocument}
              handleRemoveDocument={handleRemoveDocument}
              selectedDocs={selectedDocs}
              onDismiss={onDismiss}
            />
          </Container>
        )}
        {docSelectMode === DOC_SELECT_MODES.myDocs && (
          <Container top={0}>
            <MyUploadedDocumentSelection
              presetParams={docTypePresetParams}
              handleAddDocument={handleAddDocument}
              handleRemoveDocument={handleRemoveDocument}
              selectedDocs={selectedDocs}
              onDismiss={onDismiss}
              singleDocMode={singleDocMode}
            />
          </Container>
        )}
        {docSelectMode === DOC_SELECT_MODES.customMode && (
          <Container top={36}>
            <CustomModeDocumentSelection
              presetParams={docTypePresetParams}
              handleAddDocument={handleAddDocument}
              handleRemoveDocument={handleRemoveDocument}
              selectedDocs={selectedDocs}
              onDismiss={onDismiss}
              tool={tool}
            />
          </Container>
        )}
        {docSelectMode === DOC_SELECT_MODES.ids && (
          <DocumentIdsSelection
            selectedDocIds={selectedDocs}
            onSelect={handleAddDocument}
            onRemoveSelect={handleRemoveDocument}
          />
        )}
      </Container>
*/
